import axios, {AxiosResponse} from 'axios';
import {Story} from 'entities/story';
import {buildStoryURL} from '@/utils/urlBuilder';
import {StoryboardAccessType} from 'entities/storyboard';

export interface UserSelectOption {
    value: string | number;
    label?: string;
}

export interface StoryUserAccessPostData {
    users: UserSelectOption[];
    accessType: {
        label: string;
        value: StoryboardAccessType;
    }
}

export const shareStory = async (storyId: number, formData: StoryUserAccessPostData) => {
    return await axios.post<Story, AxiosResponse<Story, StoryUserAccessPostData>, StoryUserAccessPostData>(
        buildStoryURL('shareStory', storyId), formData,
    );
};
